import usePosOrderCurrentAction from "@/shared/atoms/usePosOrderCurrentAction";
import usePosOrderSelectedCartItemIndex from "@/shared/atoms/usePosOrderSelectedCartItemIndex";
import { useCart, useReplaceCartItem } from "@/shared/hooks/useCartHook";
import { getRandomNegativeId } from "@/shared/utils/helpers";
import useIsWaiter from "@/shared/hooks/useIsWaiter";
import useActionClick from "./useActionClick";
import PosMenuBottomActionButton, {
  PosMenuAction,
} from "../PosMenu/PosMenuBottomActionButton";
import { useTranslation } from "react-i18next";
import { CurrentActionTypes } from "@/shared/atoms/usePosOrderCurrentAction";
import { useMemo } from "react";

const useChangeProductPriceAction = (): PosMenuAction => {
  const { t } = useTranslation();
  /* const isWaiter = useIsWaiter(); */
  const [selectedCartItemIndex] = usePosOrderSelectedCartItemIndex();
  const [cart] = useCart();
  const replaceCartItem = useReplaceCartItem();

  const selectedCartItem = useMemo(
    () => cart[selectedCartItemIndex] ?? {},
    [cart, selectedCartItemIndex],
  );

  return {
    name: "changeProductPrice" as CurrentActionTypes,
    label: t("posOrders.changeProductPrice"),
    set: (newPrice) => {
      replaceCartItem(
        {
          ...selectedCartItem,
          price: newPrice,
          item_id: getRandomNegativeId(),
        },
        selectedCartItemIndex,
      );
    },
    filtered: false,
    disabled: selectedCartItemIndex === null,
    iconVariant:"edit",
  };
};

const ChangeProductPriceAction = () => {
  const [currentAction] = usePosOrderCurrentAction();
  const action = useChangeProductPriceAction();
  const handleClick = useActionClick(action);

  return (
    <PosMenuBottomActionButton
      action={action}
      isSelected={currentAction?.name === action.name}
      onClick={handleClick}
    />
  );
};

export default ChangeProductPriceAction;
